import { Link } from 'react-router-dom';
import { ROUTES } from '../constants/contstants';
import registerStyles from './Register.module.css';

const Register = () => (
  <div className={registerStyles.container}>
    <div className={registerStyles.registerCard}>
      <div className={registerStyles.header}>
        <h1 className={registerStyles.title}>Join 247Labs Academy</h1>
        <p className={registerStyles.subtitle}>
          Academy registration is invitation-only. Use the one-time code sent to your email to begin.
        </p>
      </div>

      <Link to={ROUTES.ONBOARDING} className={registerStyles.submitButton}>
        Enter invitation code
      </Link>

      <p className={registerStyles.loginLink}>
        Already registered?
        <Link to={ROUTES.LOGIN} className={registerStyles.loginLinkButton}> Sign in</Link>
      </p>
    </div>
  </div>
);

export default Register;
